import getConfig from 'next/config';

import { isServer } from '../utils';
import { getProdServicesForTesting } from '../utils/getProdServicesForTesting';

export const getMicrocreditsRequestUrl = (path: string) => {
  const { isTestingAllowed, microcreditsUrl } = getProdServicesForTesting();

  if (isTestingAllowed) {
    return microcreditsUrl;
  }

  return isServer
    ? `${process.env.MICROCREDITS}/v1/public/microCredit${path}`
    : `${getConfig().publicRuntimeConfig.publicUrl}/v1/microCredit${path}`;
};
